/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectFormat } from '../model/businessObjectFormat';
import { BusinessObjectFormatAttributeDefinitionsUpdateRequest } from '../model/businessObjectFormatAttributeDefinitionsUpdateRequest';
import { BusinessObjectFormatAttributesUpdateRequest } from '../model/businessObjectFormatAttributesUpdateRequest';
import { BusinessObjectFormatAvailabilityDayUpdateRequest } from '../model/businessObjectFormatAvailabilityDayUpdateRequest';
import { BusinessObjectFormatCreateRequest } from '../model/businessObjectFormatCreateRequest';
import { BusinessObjectFormatDdl } from '../model/businessObjectFormatDdl';
import { BusinessObjectFormatDdlCollectionRequest } from '../model/businessObjectFormatDdlCollectionRequest';
import { BusinessObjectFormatDdlCollectionResponse } from '../model/businessObjectFormatDdlCollectionResponse';
import { BusinessObjectFormatDdlRequest } from '../model/businessObjectFormatDdlRequest';
import { BusinessObjectFormatKeys } from '../model/businessObjectFormatKeys';
import { BusinessObjectFormatLegalHoldUpdateRequest } from '../model/businessObjectFormatLegalHoldUpdateRequest';
import { BusinessObjectFormatParentsUpdateRequest } from '../model/businessObjectFormatParentsUpdateRequest';
import { BusinessObjectFormatPublishingFrequencyUpdateRequest } from '../model/businessObjectFormatPublishingFrequencyUpdateRequest';
import { BusinessObjectFormatRecordFlagUpdateRequest } from '../model/businessObjectFormatRecordFlagUpdateRequest';
import { BusinessObjectFormatRetentionInformationUpdateRequest } from '../model/businessObjectFormatRetentionInformationUpdateRequest';
import { BusinessObjectFormatSampleQueryUpdateRequest } from '../model/businessObjectFormatSampleQueryUpdateRequest';
import { BusinessObjectFormatSchemaBackwardsCompatibilityUpdateRequest } from '../model/businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest';
import { BusinessObjectFormatSearchRequest } from '../model/businessObjectFormatSearchRequest';
import { BusinessObjectFormatSearchResponse } from '../model/businessObjectFormatSearchResponse';
import { BusinessObjectFormatSingletonTypeUpdateRequest } from '../model/businessObjectFormatSingletonTypeUpdateRequest';
import { BusinessObjectFormatUpdateRequest } from '../model/businessObjectFormatUpdateRequest';
import { BusinessObjectFormatUsageNotesUpdateRequest } from '../model/businessObjectFormatUsageNotesUpdateRequest';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectFormatService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createBusinessObjectFormat
     * Creates a new business object format. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param businessObjectFormatCreateRequest the information needed to create the business object format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatCreateBusinessObjectFormat(businessObjectFormatCreateRequest: BusinessObjectFormatCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatCreateBusinessObjectFormat(businessObjectFormatCreateRequest: BusinessObjectFormatCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatCreateBusinessObjectFormat(businessObjectFormatCreateRequest: BusinessObjectFormatCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatCreateBusinessObjectFormat(businessObjectFormatCreateRequest: BusinessObjectFormatCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectFormatCreateRequest === null || businessObjectFormatCreateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatCreateRequest was null or undefined when calling businessObjectFormatCreateBusinessObjectFormat.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormats`,
            businessObjectFormatCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteBusinessObjectFormat
     * Deletes an existing business format. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatDeleteBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatDeleteBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatDeleteBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatDeleteBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatDeleteBusinessObjectFormat.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatDeleteBusinessObjectFormat.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatDeleteBusinessObjectFormat.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatDeleteBusinessObjectFormat.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling businessObjectFormatDeleteBusinessObjectFormat.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormats/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * generateBusinessObjectFormatDdl
     * Retrieves the DDL to initialize the specified type of the database system (e.g. Hive) by creating a table for the requested business object format.
     * @param businessObjectFormatDdlRequest the business object data DDL request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatGenerateBusinessObjectFormatDdl(businessObjectFormatDdlRequest: BusinessObjectFormatDdlRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormatDdl>;
    public businessObjectFormatGenerateBusinessObjectFormatDdl(businessObjectFormatDdlRequest: BusinessObjectFormatDdlRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormatDdl>>;
    public businessObjectFormatGenerateBusinessObjectFormatDdl(businessObjectFormatDdlRequest: BusinessObjectFormatDdlRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormatDdl>>;
    public businessObjectFormatGenerateBusinessObjectFormatDdl(businessObjectFormatDdlRequest: BusinessObjectFormatDdlRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectFormatDdlRequest === null || businessObjectFormatDdlRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatDdlRequest was null or undefined when calling businessObjectFormatGenerateBusinessObjectFormatDdl.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectFormatDdl>(`${this.configuration.basePath}/businessObjectFormats/generateDdl`,
            businessObjectFormatDdlRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * generateBusinessObjectFormatDdlCollection
     * Retrieves the DDL to initialize the specified type of the database system (e.g. Hive) by creating tables for a collection of business object formats. &lt;p&gt;Requires READ permission on ALL namespaces&lt;/p&gt;
     * @param businessObjectFormatDdlCollectionRequest the business object format DDL collection request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatGenerateBusinessObjectFormatDdlCollection(businessObjectFormatDdlCollectionRequest: BusinessObjectFormatDdlCollectionRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormatDdlCollectionResponse>;
    public businessObjectFormatGenerateBusinessObjectFormatDdlCollection(businessObjectFormatDdlCollectionRequest: BusinessObjectFormatDdlCollectionRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormatDdlCollectionResponse>>;
    public businessObjectFormatGenerateBusinessObjectFormatDdlCollection(businessObjectFormatDdlCollectionRequest: BusinessObjectFormatDdlCollectionRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormatDdlCollectionResponse>>;
    public businessObjectFormatGenerateBusinessObjectFormatDdlCollection(businessObjectFormatDdlCollectionRequest: BusinessObjectFormatDdlCollectionRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectFormatDdlCollectionRequest === null || businessObjectFormatDdlCollectionRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatDdlCollectionRequest was null or undefined when calling businessObjectFormatGenerateBusinessObjectFormatDdlCollection.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectFormatDdlCollectionResponse>(`${this.configuration.basePath}/businessObjectFormats/generateDdlCollection`,
            businessObjectFormatDdlCollectionRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectFormat
     * Gets an existing business object format by alternate key.
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatGetBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion?: number, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatGetBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatGetBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatGetBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatGetBusinessObjectFormat.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatGetBusinessObjectFormat.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatGetBusinessObjectFormat.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatGetBusinessObjectFormat.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (businessObjectFormatVersion !== undefined && businessObjectFormatVersion !== null) {
            queryParameters = queryParameters.set('businessObjectFormatVersion', <any>businessObjectFormatVersion);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormats/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectFormats
     * Gets a list of business object formats for the specified business object definition name.
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param latestBusinessObjectFormatVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatGetBusinessObjectFormats(namespace: string, businessObjectDefinitionName: string, latestBusinessObjectFormatVersion?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormatKeys>;
    public businessObjectFormatGetBusinessObjectFormats(namespace: string, businessObjectDefinitionName: string, latestBusinessObjectFormatVersion?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormatKeys>>;
    public businessObjectFormatGetBusinessObjectFormats(namespace: string, businessObjectDefinitionName: string, latestBusinessObjectFormatVersion?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormatKeys>>;
    public businessObjectFormatGetBusinessObjectFormats(namespace: string, businessObjectDefinitionName: string, latestBusinessObjectFormatVersion?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatGetBusinessObjectFormats.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatGetBusinessObjectFormats.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (latestBusinessObjectFormatVersion !== undefined && latestBusinessObjectFormatVersion !== null) {
            queryParameters = queryParameters.set('latestBusinessObjectFormatVersion', <any>latestBusinessObjectFormatVersion);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectFormatKeys>(`${this.configuration.basePath}/businessObjectFormats/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getBusinessObjectFormatsWithFilters
     * Gets a list of business object formats for the specified business object definition name and business object format usage.
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param latestBusinessObjectFormatVersion latest business object format version
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatGetBusinessObjectFormatsWithFilters(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, latestBusinessObjectFormatVersion?: boolean, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormatKeys>;
    public businessObjectFormatGetBusinessObjectFormatsWithFilters(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, latestBusinessObjectFormatVersion?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormatKeys>>;
    public businessObjectFormatGetBusinessObjectFormatsWithFilters(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, latestBusinessObjectFormatVersion?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormatKeys>>;
    public businessObjectFormatGetBusinessObjectFormatsWithFilters(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, latestBusinessObjectFormatVersion?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatGetBusinessObjectFormatsWithFilters.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatGetBusinessObjectFormatsWithFilters.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatGetBusinessObjectFormatsWithFilters.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (latestBusinessObjectFormatVersion !== undefined && latestBusinessObjectFormatVersion !== null) {
            queryParameters = queryParameters.set('latestBusinessObjectFormatVersion', <any>latestBusinessObjectFormatVersion);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectFormatKeys>(`${this.configuration.basePath}/businessObjectFormats/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchBusinessObjectFormats
     * Retrieves all business object formats existing in the system per specified search filters and keys. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param businessObjectFormatSearchRequest the business object format search request
     * @param fields the field options for the business object format search response. The valid field options are: recordFlag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatSearchBusinessObjectFormats(businessObjectFormatSearchRequest: BusinessObjectFormatSearchRequest, fields?: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormatSearchResponse>;
    public businessObjectFormatSearchBusinessObjectFormats(businessObjectFormatSearchRequest: BusinessObjectFormatSearchRequest, fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormatSearchResponse>>;
    public businessObjectFormatSearchBusinessObjectFormats(businessObjectFormatSearchRequest: BusinessObjectFormatSearchRequest, fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormatSearchResponse>>;
    public businessObjectFormatSearchBusinessObjectFormats(businessObjectFormatSearchRequest: BusinessObjectFormatSearchRequest, fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (businessObjectFormatSearchRequest === null || businessObjectFormatSearchRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatSearchRequest was null or undefined when calling businessObjectFormatSearchBusinessObjectFormats.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fields !== undefined && fields !== null) {
            queryParameters = queryParameters.set('fields', <any>fields);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<BusinessObjectFormatSearchResponse>(`${this.configuration.basePath}/businessObjectFormats/search`,
            businessObjectFormatSearchRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormat
     * Updates an existing business object format by alternate key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param businessObjectFormatUpdateRequest the information needed to update the business object format
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatUpdateRequest: BusinessObjectFormatUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatUpdateRequest: BusinessObjectFormatUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatUpdateRequest: BusinessObjectFormatUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormat(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatUpdateRequest: BusinessObjectFormatUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormat.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormat.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormat.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormat.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormat.');
        }
        if (businessObjectFormatUpdateRequest === null || businessObjectFormatUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormat.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormats/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}`,
            businessObjectFormatUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatAttributeDefinitions
     * Replaces the list of attribute definitions for an existing business object format based on the specified usage, file type, version and a business object definition. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param businessObjectFormatAttributeDefinitionsUpdateRequest the information needed to update the business object format attribute definitions
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributeDefinitionsUpdateRequest: BusinessObjectFormatAttributeDefinitionsUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributeDefinitionsUpdateRequest: BusinessObjectFormatAttributeDefinitionsUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributeDefinitionsUpdateRequest: BusinessObjectFormatAttributeDefinitionsUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributeDefinitionsUpdateRequest: BusinessObjectFormatAttributeDefinitionsUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions.');
        }
        if (businessObjectFormatAttributeDefinitionsUpdateRequest === null || businessObjectFormatAttributeDefinitionsUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatAttributeDefinitionsUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributeDefinitions.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatAttributeDefinitions/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}`,
            businessObjectFormatAttributeDefinitionsUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatAttributes
     * Updates an existing business object format attributes by alternate key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt; &lt;p&gt; This endpoint replaces the entire list of attributes on the business object format with the contents of the request. Observe this example: &lt;ol&gt; &lt;li&gt;Three attributes present on the existing business object format.&lt;/li&gt; &lt;li&gt;This endpoint is called with a single attribute in the request with an updated value.&lt;/li&gt; &lt;li&gt;After this operation the business object format will have only one attribute – which is probably not the desired outcome.&lt;/li&gt; &lt;li&gt;Instead, supply all existing attributes and provide updated values and additional attributes as needed. The only case when an existing attribute should be left out is to remove the attribute.&lt;/li&gt; &lt;/ol&gt; &lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatVersion the business object format version
     * @param businessObjectFormatAttributesUpdateRequest the information needed to update the business object format attributes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributesUpdateRequest: BusinessObjectFormatAttributesUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributesUpdateRequest: BusinessObjectFormatAttributesUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributesUpdateRequest: BusinessObjectFormatAttributesUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatAttributes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, businessObjectFormatAttributesUpdateRequest: BusinessObjectFormatAttributesUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributes.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributes.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributes.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributes.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributes.');
        }
        if (businessObjectFormatAttributesUpdateRequest === null || businessObjectFormatAttributesUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatAttributesUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAttributes.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatAttributes/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}`,
            businessObjectFormatAttributesUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatAvailabilityDay
     * Updates availability day for an existing business object format without business object format version. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatAvailabilityDayUpdateRequest the information needed to update the business object format availability day
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatAvailabilityDayUpdateRequest: BusinessObjectFormatAvailabilityDayUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatAvailabilityDayUpdateRequest: BusinessObjectFormatAvailabilityDayUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatAvailabilityDayUpdateRequest: BusinessObjectFormatAvailabilityDayUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatAvailabilityDayUpdateRequest: BusinessObjectFormatAvailabilityDayUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay.');
        }
        if (businessObjectFormatAvailabilityDayUpdateRequest === null || businessObjectFormatAvailabilityDayUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatAvailabilityDayUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatAvailabilityDay.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatAvailabilityDay/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatAvailabilityDayUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatLegalHold
     * Updates legal hold status for an existing business object format by alternate key without business object format version. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatLegalHoldUpdateRequest the information needed to update the business object format legal hold
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatLegalHold(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatLegalHoldUpdateRequest: BusinessObjectFormatLegalHoldUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatLegalHold(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatLegalHoldUpdateRequest: BusinessObjectFormatLegalHoldUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatLegalHold(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatLegalHoldUpdateRequest: BusinessObjectFormatLegalHoldUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatLegalHold(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatLegalHoldUpdateRequest: BusinessObjectFormatLegalHoldUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatLegalHold.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatLegalHold.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatLegalHold.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatLegalHold.');
        }
        if (businessObjectFormatLegalHoldUpdateRequest === null || businessObjectFormatLegalHoldUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatLegalHoldUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatLegalHold.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatLegalHold/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatLegalHoldUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatParents
     * Updates an existing business object format parents by alternate key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatParentsUpdateRequest the information needed to update the business object format
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatParents(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatParentsUpdateRequest: BusinessObjectFormatParentsUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatParents(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatParentsUpdateRequest: BusinessObjectFormatParentsUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatParents(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatParentsUpdateRequest: BusinessObjectFormatParentsUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatParents(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatParentsUpdateRequest: BusinessObjectFormatParentsUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatParents.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatParents.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatParents.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatParents.');
        }
        if (businessObjectFormatParentsUpdateRequest === null || businessObjectFormatParentsUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatParentsUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatParents.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatParents/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatParentsUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatPublishingFrequency
     * Updates publishing frequency designation for an existing business object format without business object format version. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatPublishingFrequencyUpdateRequest the information needed to update the business object format publishing frequency
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatPublishingFrequencyUpdateRequest: BusinessObjectFormatPublishingFrequencyUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatPublishingFrequencyUpdateRequest: BusinessObjectFormatPublishingFrequencyUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatPublishingFrequencyUpdateRequest: BusinessObjectFormatPublishingFrequencyUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatPublishingFrequencyUpdateRequest: BusinessObjectFormatPublishingFrequencyUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency.');
        }
        if (businessObjectFormatPublishingFrequencyUpdateRequest === null || businessObjectFormatPublishingFrequencyUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatPublishingFrequencyUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatPublishingFrequency.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatPublishingFrequency/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatPublishingFrequencyUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatRecordFlag
     * Updates or resets record flag for an existing business object format by alternate key without business object format version. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatRecordFlagUpdateRequest the information needed to update the business object format legal hold
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatRecordFlag(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRecordFlagUpdateRequest: BusinessObjectFormatRecordFlagUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatRecordFlag(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRecordFlagUpdateRequest: BusinessObjectFormatRecordFlagUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatRecordFlag(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRecordFlagUpdateRequest: BusinessObjectFormatRecordFlagUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatRecordFlag(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRecordFlagUpdateRequest: BusinessObjectFormatRecordFlagUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRecordFlag.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRecordFlag.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRecordFlag.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRecordFlag.');
        }
        if (businessObjectFormatRecordFlagUpdateRequest === null || businessObjectFormatRecordFlagUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatRecordFlagUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRecordFlag.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatRecordFlag/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatRecordFlagUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatRetentionInformation
     * Updates an existing business object format retention information by alternate key. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatRetentionInformationUpdateRequest the information needed to update the business object format retention information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatRetentionInformation(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRetentionInformationUpdateRequest: BusinessObjectFormatRetentionInformationUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatRetentionInformation(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRetentionInformationUpdateRequest: BusinessObjectFormatRetentionInformationUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatRetentionInformation(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRetentionInformationUpdateRequest: BusinessObjectFormatRetentionInformationUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatRetentionInformation(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatRetentionInformationUpdateRequest: BusinessObjectFormatRetentionInformationUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRetentionInformation.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRetentionInformation.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRetentionInformation.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRetentionInformation.');
        }
        if (businessObjectFormatRetentionInformationUpdateRequest === null || businessObjectFormatRetentionInformationUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatRetentionInformationUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatRetentionInformation.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatRetentionInformation/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatRetentionInformationUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatSampleQuery
     * Updates sample query information for an existing business object format without business object format version. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatSampleQueryUpdateRequest the information needed to update the business object format sample query
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatSampleQuery(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSampleQueryUpdateRequest: BusinessObjectFormatSampleQueryUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatSampleQuery(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSampleQueryUpdateRequest: BusinessObjectFormatSampleQueryUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatSampleQuery(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSampleQueryUpdateRequest: BusinessObjectFormatSampleQueryUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatSampleQuery(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSampleQueryUpdateRequest: BusinessObjectFormatSampleQueryUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSampleQuery.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSampleQuery.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSampleQuery.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSampleQuery.');
        }
        if (businessObjectFormatSampleQueryUpdateRequest === null || businessObjectFormatSampleQueryUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatSampleQueryUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSampleQuery.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatSampleQuery/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatSampleQueryUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatSchemaBackwardsCompatibleChanges
     * Updates an existing Business Object Format to allow non-backwards compatibility changes to the format schema based on the &#39;allowNonBackwardsCompatibleChanges&#39; flag. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest the information needed to update the business object format to allow non-backwards compatibility changes to the format schema
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest: BusinessObjectFormatSchemaBackwardsCompatibilityUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest: BusinessObjectFormatSchemaBackwardsCompatibilityUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest: BusinessObjectFormatSchemaBackwardsCompatibilityUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest: BusinessObjectFormatSchemaBackwardsCompatibilityUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges.');
        }
        if (businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest === null || businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSchemaBackwardsCompatibleChanges.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatSchemaBackwardsCompatibility/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatSchemaBackwardsCompatibilityUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatSingletonType
     * Updates singleton type designation for an existing business object format without business object format version. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatSingletonTypeUpdateRequest the information needed to update the business object format singleton type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatSingletonType(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSingletonTypeUpdateRequest: BusinessObjectFormatSingletonTypeUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatSingletonType(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSingletonTypeUpdateRequest: BusinessObjectFormatSingletonTypeUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatSingletonType(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSingletonTypeUpdateRequest: BusinessObjectFormatSingletonTypeUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatSingletonType(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatSingletonTypeUpdateRequest: BusinessObjectFormatSingletonTypeUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSingletonType.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSingletonType.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSingletonType.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSingletonType.');
        }
        if (businessObjectFormatSingletonTypeUpdateRequest === null || businessObjectFormatSingletonTypeUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatSingletonTypeUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatSingletonType.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatSingletonType/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatSingletonTypeUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateBusinessObjectFormatUsageNotes
     * Updates usage notes for an existing business object format without business object format version. &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param namespace the namespace code
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param businessObjectFormatUsageNotesUpdateRequest the information needed to update the business object format usage notes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatUpdateBusinessObjectFormatUsageNotes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatUsageNotesUpdateRequest: BusinessObjectFormatUsageNotesUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormat>;
    public businessObjectFormatUpdateBusinessObjectFormatUsageNotes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatUsageNotesUpdateRequest: BusinessObjectFormatUsageNotesUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatUsageNotes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatUsageNotesUpdateRequest: BusinessObjectFormatUsageNotesUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormat>>;
    public businessObjectFormatUpdateBusinessObjectFormatUsageNotes(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatUsageNotesUpdateRequest: BusinessObjectFormatUsageNotesUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatUsageNotes.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatUsageNotes.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatUsageNotes.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatUsageNotes.');
        }
        if (businessObjectFormatUsageNotesUpdateRequest === null || businessObjectFormatUsageNotesUpdateRequest === undefined) {
            throw new Error('Required parameter businessObjectFormatUsageNotesUpdateRequest was null or undefined when calling businessObjectFormatUpdateBusinessObjectFormatUsageNotes.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<BusinessObjectFormat>(`${this.configuration.basePath}/businessObjectFormatUsageNotes/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}`,
            businessObjectFormatUsageNotesUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
